import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { WeeklyIdea, WeeklyIdeasResponse } from '../../components/campaigns/types';

interface WeeklyIdeasState {
  data: WeeklyIdea[];
  loading: boolean;
  error: string | null;
  count: number;
}

const initialState: WeeklyIdeasState = {
  data: [],
  loading: false,
  error: null,
  count: 0,
};

const weeklyIdeasSlice = createSlice({
  name: 'weeklyIdeas',
  initialState,
  reducers: {
    fetchWeeklyIdeasRequest: (state, _action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchWeeklyIdeasSuccess: (state, action: PayloadAction<WeeklyIdeasResponse>) => {
      state.loading = false;
      state.data = action.payload.data;
      state.count = action.payload.count;
      state.error = null;
    },
    fetchWeeklyIdeasFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchWeeklyIdeasRequest,
  fetchWeeklyIdeasSuccess,
  fetchWeeklyIdeasFailure,
} = weeklyIdeasSlice.actions;

export default weeklyIdeasSlice.reducer;
